'use strict';

let requireOrNull = require;
if (!process.env.WEBPACK) {
  requireOrNull = str => str;
}

const critModules = [
  {
    name: 'BuyButton',
    module: requireOrNull(
      '../../../../modules/buy_button/desktop_2016/frontend/buy_button'
    ),
    featureCheck: serverObj =>
      serverObj.buyButton && !serverObj.usesBuyButtonForm,
  },
  {
    name: 'Variations',
    module: requireOrNull(
      '../../../../modules/variations/frontend/variations-widget'
    ),
    featureCheck: serverObj => serverObj.variations,
  },
  {
    name: 'Cart',
    module: requireOrNull('../../../../modules/cart/frontend/index'),
    featureCheck: serverObj => serverObj.cart,
  },
];

const nonCritModules = [
  {
    name: 'AsyncScripts',
    module: requireOrNull('../async_scripts/goods'),
  },
  {
    name: 'StaticPages',
    module: requireOrNull('../../../../modules/static_pages/frontend/index'),
    featureCheck: serverObj => serverObj.staticPages,
  },
  {
    name: 'GoodsWarranty',
    module: requireOrNull('../../../../modules/goods_warranty/frontend/index'),
    featureCheck: serverObj => serverObj.goodsWarranty,
  },
  {
    name: 'ProductBundles',
    module: requireOrNull('../../../../modules/product_bundles/frontend/index'),
    featureCheck: serverObj => serverObj.productBundles,
  },
  {
    name: 'FinePrint',
    module: requireOrNull('../../../../modules/fine_print/frontend/index'),
    featureCheck: serverObj => serverObj.finePrint,
  },
  {
    name: 'Wishlist',
    module: requireOrNull(
      '../../../../modules/wishlist_button/frontend/wishlist'
    ),
    featureCheck: serverObj => serverObj.wishlist,
  },
  {
    name: 'Pitch',
    module: requireOrNull('../../../../modules/deal/frontend/pitch'),
  },
  {
    name: 'GoodsUkShipping',
    module: requireOrNull('../../../../modules/goods_uk_shipping/frontend'),
    featureCheck: serverObj => !!serverObj.goodsUkShipping,
  },
  {
    name: 'MSRP',
    module: requireOrNull('../../../../modules/msrp/frontend/desktop'),
    featureCheck: serverObj => serverObj.msrp,
  },
];

module.exports = { critModules, nonCritModules };
